import TransactionsList from '../../components/Gamification/TransactionsList';
import TransactionsListItemSkeleton from '../../components/Gamification/TransactionsListItemSkeleton';
import { useGamification } from '../../providers/GamificationProvider';
import { __, dummyArray, formatPoints } from '../../utils';
import { Box, Stack, Tab, Tabs, Typography } from '@presov.sk/presov-ui-react';
import React from 'react';

type Props = {
  initModalTransactionId?: number;
};

const LoyaltyPoints: React.FC<Props> = ({ initModalTransactionId }) => {
  // State for internal tabs
  const [pointsSelectedTab, setPointsSelectedTab] = React.useState<number>();
  const { pointAccounts, isLoadingPointAccounts } = useGamification();
  // Initialize points tab
  React.useEffect(() => {
    if (pointAccounts.length > 0 && !pointsSelectedTab) {
      setPointsSelectedTab(pointAccounts[0].account_id);
    }
  }, [pointAccounts, pointsSelectedTab]);

  return isLoadingPointAccounts ? (
    dummyArray(5).map((_, index) => (
      <TransactionsListItemSkeleton key={index} />
    ))
  ) : pointAccounts.length === 0 ? (
    <Box
      display='flex'
      flexDirection={'column'}
      alignItems='center'
      justifyContent='start'
      mt={6}
      mb={9}
    >
      <Typography variant='body1'>{__('Žiadne vernostné body.')}</Typography>
      <Typography variant='body2' sx={{ fontStyle: 'italic' }}>
        {__(
          'Vernostné body môžete získať nahratím podnetu alebo zapojením sa do hlasovania.',
        )}
      </Typography>
    </Box>
  ) : (
    // Nadpis sekcie tu nie je - je to titul stránky ([[ProfilePage]]).
    <Stack gap={2} sx={{ height: '100%' }}>
      {pointAccounts.length > 1 && (
        <Tabs
          value={pointsSelectedTab}
          onChange={(_, value) => setPointsSelectedTab(value)}
          variant='scrollable'
        >
          {pointAccounts.map((acc) => (
            <Tab
              key={acc.account_id}
              label={
                <Stack direction={'row'} alignItems={'center'} gap={0.5}>
                  {acc.name}
                  <Box
                    sx={{
                      backgroundColor: (theme) => theme.palette.info.main,
                      color: (theme) => theme.palette.primary.contrastText,
                      fontSize: 12,
                      py: 0.1,
                      px: 0.7,
                      borderRadius: 1,
                    }}
                  >
                    {formatPoints(acc?.balance || 0)}
                  </Box>
                </Stack>
              }
              value={acc.account_id}
            />
          ))}
        </Tabs>
      )}
      {/* Zoznam sa polohuje absolútne, takže potrebuje vlastný rám pod hlavičkou */}
      <Stack sx={{ position: 'relative', flex: 1, minHeight: 0 }}>
        {pointAccounts.map((accountName) =>
          pointsSelectedTab === accountName.account_id ? (
            <TransactionsList
              initModalTransactionId={initModalTransactionId}
              key={accountName.account_id}
              accountId={accountName.account_id}
            />
          ) : null,
        )}
      </Stack>
    </Stack>
  );
};

export default LoyaltyPoints;
